"use client";

import { Button, Group, Menu, Text } from "@mantine/core";
import { IconChevronDown, IconExternalLink } from "@tabler/icons-react";

import CopyPill from "@/app/(marketing)/components/CopyPill";
import {
  AGENT_SETUP_COMMAND,
  CLAUDE_INSTALL_URL,
  CONNECT_CLIENT,
} from "@/app/(marketing)/integrations/constants";

import { jumpToConnectClient } from "./connect-hash";

/** The hero's action row: one vendor-neutral Connect chooser, "or", and the
    one line an agent can follow on its own, ready to copy; the bare server URL
    stays in every walkthrough below. Every item selects its walkthrough;
    Claude, the only client with an install link, also opens claude.ai in a
    new tab so the steps are waiting when the person comes back. */
export default function ConnectRow() {
  return (
    <Group gap="md" align="center">
      <Menu shadow="md" width={200} position="bottom-start">
        <Menu.Target>
          <Button
            size="md"
            variant="gradient"
            gradient={{ from: "blue", to: "cyan", deg: 90 }}
            rightSection={<IconChevronDown size={16} />}
          >
            Connect
          </Button>
        </Menu.Target>
        <Menu.Dropdown>
          <Menu.Item
            component="a"
            href={CLAUDE_INSTALL_URL}
            target="_blank"
            rel="noopener noreferrer"
            rightSection={<IconExternalLink size={14} />}
            onClick={() => jumpToConnectClient(CONNECT_CLIENT.CLAUDE)}
          >
            Claude
          </Menu.Item>
          <Menu.Item onClick={() => jumpToConnectClient(CONNECT_CLIENT.CHATGPT)}>ChatGPT</Menu.Item>
          <Menu.Item onClick={() => jumpToConnectClient(CONNECT_CLIENT.CLAUDE_CODE)}>
            Claude Code
          </Menu.Item>
          <Menu.Item onClick={() => jumpToConnectClient(CONNECT_CLIENT.OTHER)}>
            Other Agents
          </Menu.Item>
        </Menu.Dropdown>
      </Menu>

      <Text size="sm" c="gray.6">
        or
      </Text>

      <CopyPill value={AGENT_SETUP_COMMAND} />
    </Group>
  );
}
